/* Evergreen: keep Dawn's cart icon in sync with AJAX cart changes.
 * Verified against the storefront's current Replo fetch-based cart actions.
 * Install once in layout/theme.liquid; no product-button edits are needed.
 */
(() => {
  if (window.__evergreenCartCountInstalled || !window.fetch) return;
  window.__evergreenCartCountInstalled = true;

  const originalFetch = window.fetch;
  const root = window.Shopify?.routes?.root || '/';
  const mutationPaths = new Set(
    [...new Set(['/', root])].flatMap(base =>
      ['add', 'change', 'update', 'clear'].flatMap(action => [
        `${base}cart/${action}`, `${base}cart/${action}.js`
      ])
    )
  );
  let revision = 0;
  let refreshing = false;

  function isCartWrite(input, options) {
    try {
      const url = new URL(
        typeof input === 'string' || input instanceof URL ? input : input.url,
        window.location.href
      );
      const method = String(options?.method || input?.method || 'GET').toUpperCase();
      return method === 'POST' && url.origin === window.location.origin &&
        mutationPaths.has(url.pathname);
    } catch (_) {
      return false;
    }
  }

  async function refreshIcon() {
    if (refreshing) return;
    refreshing = true;
    let renderedRevision;

    try {
      do {
        renderedRevision = revision;
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 8000);
        try {
          const url = new URL(root, window.location.origin);
          url.searchParams.set('sections', 'cart-icon-bubble');
          const response = await originalFetch.call(window, url.href, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal
          });
          if (!response.ok) throw new Error(`Section request returned ${response.status}`);
          const sections = await response.json();
          const html = sections['cart-icon-bubble'];
          if (typeof html !== 'string') throw new Error('Cart icon section is missing');
          const section = new DOMParser().parseFromString(html, 'text/html')
            .getElementById('shopify-section-cart-icon-bubble');
          if (!section) throw new Error('Cart icon section markup is missing');

          // A newer cart write may have completed while the section was loading.
          if (renderedRevision === revision) {
            const icon = document.getElementById('cart-icon-bubble');
            if (icon) icon.innerHTML = section.innerHTML;
          }
        } catch (error) {
          console.warn('[Evergreen cart count] Could not refresh the icon.', error);
        } finally {
          window.clearTimeout(timeout);
        }
      } while (renderedRevision !== revision);
    } finally {
      refreshing = false;
    }
  }

  window.fetch = function(input, options) {
    const isMutation = isCartWrite(input, options);
    const request = originalFetch.apply(this, arguments);
    if (isMutation) {
      // Observe the result without consuming its body, delaying it, or replacing it.
      request.then(response => {
        if (response.ok) {
          revision += 1;
          void refreshIcon();
        }
      }, () => {});
    }
    return request;
  };
})();
